import { render, staticRenderFns } from "./app-details-card.vue?vue&type=template&id=982349fc&scoped=true&"
import script from "./app-details-card.vue?vue&type=script&lang=js&"
export * from "./app-details-card.vue?vue&type=script&lang=js&"
import style0 from "./app-details-card.vue?vue&type=style&index=0&id=982349fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982349fc",
  null
  
)

export default component.exports